<template>
  <input
    v-model="v$.confirmation.$model"
    :class="{ 'error-form-input': v$.confirmation.$error }"
    id="checkConfirmation"
    name="checkConfirmation"
    :true-value="true"
    :false-value="false"
    type="checkbox"
    class="custom-checkbox-test"
    @change="$emit('checkConfirmation', confirmation)"
  />
</template>

<script>
//Vuelidate
import useVuelidate from "@vuelidate/core";
export default {
  props: {
    confirmationAuthorization: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      v$: useVuelidate(),
      confirmation: this.confirmationAuthorization,
    };
  },
  watch: {
    confirmationAuthorization(newValue) {
      const me = this;
      me.confirmation = newValue;
    },
  },
  validations: {
    confirmation: {
      checked(val) {
        return val;
      },
    },
  },
};
</script>
